import {useRive} from "@rive-app/react-canvas";
import feedBackAnimation from "../../assets/feed_back_animation.png";

const FeedBack = (riveProps) => {
    const {rive, RiveComponent} = useRive({
        src: feedBackAnimation,
        stateMachines: "State Machine 1",
        autoplay: true,
        onLoadError: () => console.log("ERROR LOADING RIVE"),
        onLoad: () => console.log("LOADED RIVE"),
    });

    return <RiveComponent style={{width: "600px", height: "400px"}}/>;
};

export default FeedBack;